import _ from 'lodash'

export default class {
  constructor(content, minRadius, maxRadius) {
    this.content = content
    this.minRadius = minRadius
    this.maxRadius = maxRadius
    this.points = []
    this.wrongLines = []
    this.process()
  }

  process() {
    let lines = this.content.split(/[\r\n]+/g)

    this.wrongLines = []
    this.points = _.filter(_.map(lines, (line) => this.parseLine(line)))
  }

  parseLine(line) {
    line = line.trim()

    if (line.length === 0) return null
    let point = {}
    try {
      point = line.indexOf(':') !== -1 ? this.parseMyTarget(line) : this.parseSimple(line)
    } catch (e) {
      point = {}
    }

    if (this.checkPoint(point)) {
      return point
    } else {
      this.wrongLines.push(line)
      return null
    }
  }

  parseSimple(line) {
    let data = line.split(';')
    const latIndex = data.length === 4 ? 1 : 0
    return {
      name: latIndex === 0 ? '' : data[0],
      latitude: parseFloat(data[latIndex]),
      longitude: parseFloat(data[latIndex + 1]),
      radius: parseFloat(data[latIndex + 2])
    }
  }

  parseMyTarget(line) {
    let parts = line.split(':')
    let coords = parts[2].split(',')
    return {
      name: parts[0],
      radius: parseFloat(parts[1]) / 1000,
      latitude: parseFloat(coords[0]),
      longitude: parseFloat(coords[1])
    }
  }

  checkPoint(point) {
    let latitude = point.latitude
    let longitude = point.longitude
    let radius = point.radius
    if (latitude < -90 || latitude > 90) return false
    if (longitude < -180 || longitude > 180) return false

    return radius >= this.minRadius && radius <= this.maxRadius
  }
}
